import * as React from 'react'
import bubbleIcon from 'assets/check/bubble.svg'

const Bubble = props => (
  <div
    {...props}
    style={{
      backgroundImage: `url(${bubbleIcon})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain',
      ...props.style,
    }}
  >
    {props.children}
  </div>
)

export default Bubble
